<template>
    <AdvancedRouterLink :to="item.routeLocation">
        <template #content>
            <ListCard
                :title="item.title"
                :highlight="item.highlight"
                :image-separator="!!item.previewImageUrl"
                :index="index"
                :image-src="item.previewImageUrl"
                :fallback-icon="getEntryImageClasses(item)"
            >
                <template #subtitle>
                    <!-- @vue-ignore -->
                    <div v-if="item.rootContentMapTitle" class="col subtitle light-text-color qit-text-ellipsis">
                        <!-- @vue-ignore -->
                        {{ $t("documentation.in {path}", { path: item.rootContentMapTitle }) }}
                    </div>
                    <div v-if="item.subheading" class="col subtitle light-text-color qit-text-ellipsis">
                        {{ item.subheading }}
                    </div>
                </template>
                <template #content>
                    <div
                        v-if="item.properties"
                        class="row"
                        :class="{ 'col-gap-xxl': $q.screen.gt.xs, 'col-gap-l': $q.screen.lt.sm }"
                    >
                        <PropertyView :items="item.properties" :max-property-width="180" />
                    </div>
                </template>
                <template #buttons>
                    <div class="row-auto q-ma-sm">
                        <MoreMenu v-if="moreMenuEntries" :entries="moreMenuEntries" />
                    </div>
                </template>
            </ListCard>
        </template>
    </AdvancedRouterLink>
</template>

<script setup lang="ts">
import { MenuTextEntry } from "@/shared/components/menu/menu.model";
import MoreMenu from "@/shared/components/menu/more-menu.vue";
import PropertyView from "@/shared/components/views/property-view.vue";
import AdvancedRouterLink from "@/shared/components/router-link/advanced-router-link.vue";
import ListCard from "@/shared/components/card/list-card.vue";
import { CollectionEntryTypes } from "@/abilities/collections/components/collection-entry.types.ts";

defineProps<{
    item: CollectionEntryTypes;
    moreMenuEntries?: MenuTextEntry[];
    index?: number;
}>();

defineEmits<{
    openOverlayRight: [];
    delete: [];
}>();

const getEntryImageClasses = (item: CollectionEntryTypes) => {
    if (item.__typename === "Article" || item.__typename === "MechanicArticle") {
        return "fa-gear default-grey-icon-color";
    } else if (item.__typename === "Documentation") {
        if (item.isTopic) return "fa-file-lines default-grey-icon-color";
        return "fa-book-blank default-grey-icon-color";
    } else if (item.__typename === "Activity") {
        return "fa-wrench default-grey-icon-color";
    }

    return "";
};
</script>
